<template>
    <aside class="Nag absolute-center p-2 fixed-top flex-wrap-nowrap d-inline-flex justify-content-center align-items-center text-white bg-primary flex-nowrap">
        <i class="Nag__icon fs-2 mr-2" :class="icon"></i>
        <div class="Nag__message" v-html="message"></div>
        <a class="Nag__action cta cta--secondary ml-2 btn btn-light" :href="action">{{verb}}</a>
    </aside>
</template>

<script>
    export default {
        name: 'Nag',
        props: {
            message: {
                type: String,
                default: ''
            },
            action: {
                type: String,
                default: ''
            },
            verb: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            }
        }
    }
 </script>
